package org.gstechnovos.jexonplastech.theme

import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import org.jetbrains.compose.web.css.*

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier.scrollBehavior(ScrollBehavior.Smooth)
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .margin(0.px)
            .fontFamily(
                "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
                "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "sans-serif"
            )
            .fontSize(16.px) // Standardized for B2B dashboards
            .lineHeight(1.5)
            .backgroundColor(Colors.White)
            .color(SitePalettes.light.custom.darkText)
    }

    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth()
    }
}

val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(2.5.cssRem)
        .textAlign(TextAlign.Start)
        .lineHeight(1.2)
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.125.cssRem)
        .textAlign(TextAlign.Start)
        .whiteSpace(WhiteSpace.PreWrap)
        .color(colorMode.toPalette().color.toRgb())
}

val PrimaryButtonVariant = ButtonStyle.addVariantBase {
    Modifier
        .backgroundColor(SitePalettes.light.brand.actionRed)
        .color(Colors.White)
        .padding(topBottom = 12.px, leftRight = 24.px)
        .borderRadius(4.px) // Slightly squared edges for manufacturing feel
}

/**
 * Provides baseline friction against casual asset theft of proprietary product photography.
 * Apply this directly to the Image() modifiers in the Product Showcase[cite: 55, 56].
 */
fun Modifier.unextractable(): Modifier {
    return this
        .userSelect(UserSelect.None)
        .styleModifier {
            property("-webkit-user-drag", "none")
            property("-khtml-user-drag", "none")
            property("-moz-user-drag", "none")
            property("-o-user-drag", "none")
        }
        .attrsModifier {
            attr("draggable", "false")
            onContextMenu { it.preventDefault() }
        }
}